<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Menuscript</li>
                <li></li>
            </ul>
            <h2 i18n>List of Menuscripts</h2>
        </div>
    </div>
</div>

<div class="blog-area ptb-100" [class.dark-blog-area]="themeService.isDark()">
    <div class="container">
        <div class="row pb-5">
            <h3 i18n>All Menuscripts</h3>
            <div class="woocommerce-topbar">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="topbar-ordering-and-search">
                            <div class="row align-items-center">
                                <form [formGroup]="filter_form" (submit)="applyFilter()">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12">
                                            <div class="billing-details">
                                                <div class="row">
                                                    <div class="col-lg-6 col-md-6 pt-3">
                                                        <div class="form-group">
                                                            <label i18n>Title</label>
                                                            <input type="text" formControlName="title"
                                                                class="form-control">

                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4 pt-3">
                                                        <div class="form-group">
                                                            <label>&nbsp;<span></span></label>
                                                            <button type="submit" value="Filter" class="default-btn">
                                                                <i class='bx bx-filter-alt icon-arrow before'></i><span
                                                                    class="label" i18n>Filter</span><i
                                                                    class="bx bx-filter-alt icon-arrow after"></i>
                                                            </button>
                                                            &nbsp; &nbsp;
                                                            <a (click)="resetFilter()" class="back-btn">
                                                                <i class='bx bx-reset icon-arrow before'></i><span
                                                                    class="label"i18n>Reset</span><i
                                                                    class="bx bx-reset icon-arrow after"></i>
                                                            </a>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="row" *ngFor="let menuscript of menuscripts">
                <div class="col-lg-12 col-md-12">
                    <div class="single-courses-list-box mb-30">
                        <div class="box-item">
                            <div class="courses-image" >
                                <div class="image" [style]="'background-image: url('+imageUrl + menuscript.images[0].url+')'">
                                    <a routerLink="/menuscripts/{{menuscript.id}}" class="link-btn"></a>
                                </div>
                            </div>
                            <div class="courses-desc">
                                <div class="courses-content">
                                    <h3><a routerLink="/menuscripts/{{menuscript.id}}" class="d-inline-block">{{menuscript.title}}</a></h3>
                                    
                                    <p>{{menuscript.script|slice:0:550}}</p>
                                </div>
                                <div class="courses-box-footer">
                                    <ul>
                                        <li class="students-number">
                                            <span i18n>Created Date</span>: <i class='bx bx-calendar'></i> {{menuscript.created_at|date:'longDate'}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-12 col-md-12 col-sm-12">
                <app-pagination [currentPage]="currentPage" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems"
                    (pageChanged)="onPageChange($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>